export const WORKFLOW_ACTIVE_PROJECT_KEY = 'workflow_active_project_id';

export function getActiveProjectId(): string | null {
  return sessionStorage.getItem(WORKFLOW_ACTIVE_PROJECT_KEY);
}

export function setActiveProjectId(projectId: string) {
  sessionStorage.setItem(WORKFLOW_ACTIVE_PROJECT_KEY, projectId);
}

export function clearActiveProjectId() {
  sessionStorage.removeItem(WORKFLOW_ACTIVE_PROJECT_KEY);
}
